module.exports = __webpack_public_path__ + "static/media/naruxforpokeLogo.320693fa.png";